// PreviousPageIcon.js
import React from 'react';

const PreviousPageIcon = ({ className, width = "24", height = "24" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
    width={width}
    height={height}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7m5 14V5m0 14h-2m2 0h-2m2 0v2m0-4V3m0 14h2m-2 0h2" />
  </svg>
);

export default PreviousPageIcon;
